// extracted by mini-css-extract-plugin
export default {"bannerPic":"index_bannerPic_uPxqb","current":"index_current_LMB-s","pic_img":"index_pic_img_miyTj","trans":"index_trans_L8w8Q","text":"index_text_Sdx0D","title":"index_title_dRagl"};